export const ARTNET_IMAGE_MIN_WIDTH = 800;
export const ARTNET_IMAGE_MAXIMUM_SIZE = 10000000;
export const ARTNET_IMAGE_MINIMUM_SIZE = 1;
